import { useContext } from "react";
import { RebatesFilterContext } from "./RebatesFilterContext";
import { RebatesFilterContextType } from "../../types/types";
import { FilterChip } from "@/components/search-filter/FilterChip";

export const RebatesFilterChips = () => {
  const { selectedFilterChips, setFilterIsOpen, setOpenSectionIds } =
    useContext(RebatesFilterContext) as RebatesFilterContextType;

  return (
    <>
      {selectedFilterChips.map((filterChip) => (
        <FilterChip
          key={filterChip.label + filterChip.sectionId}
          label={filterChip.label}
          onClickHandler={() => {
            setOpenSectionIds([filterChip.sectionId]);
            setFilterIsOpen(true);
          }}
        />
      ))}
    </>
  );
};
